<template>
  <v-card id="account-setting-card">
    <v-card-title class="justify-center">
      <span class="text-h5"><strong>TISSUE DETAILS</strong></span>
    </v-card-title>
   
    <!-- <v-tabs
      v-model="tab"
      show-arrows
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.icon"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs>

   
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <TissueDetailOD />
      </v-tab-item>

      <v-tab-item>
        <TissueDetailOS/>
      </v-tab-item>
    </v-tabs-items> -->
     <v-tabs v-model="active_tab">
      <v-tab
        key="0"
        :disabled="readOnlyField === true"
      >
        <span>OS (oculus sinister)</span>
      </v-tab>

      <v-tab
        key="1"
        :disabled="readOnlyField1 === true"
      >
        
        <span>OD (oculus dextrus)</span>
      </v-tab>
      
    </v-tabs>

    <!-- tabs item -->
    <v-tabs-items v-model="active_tab">
      <v-tab-item key="0">
         <TissueDetailOS/>
      </v-tab-item>
      <v-tab-item key="1">
       
        <TissueDetailOD />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'

// demos
import TissueService from "@/service/Tissue.service"
import TissueDetailOD from './TissueDetailOD.vue'
import TissueDetailOS from './TissueDetailOS.vue'

export default {
  components: {
    TissueDetailOD,
    TissueDetailOS,
   
  },
  setup() {
    // const tab = ref('')

    // // tabs
    // const tabs = [
    //    { title: 'Tissus Details OD(Right Eye)'},
    //    { title: 'Tissus Details OS(Left Eye)'},
      
    // ]
     return {
      // tab: "tab2",
      readOnlyField: false,
      readOnlyField1: false,
      active_tab: 0,
    }
  
    // return {
    //   tab,
    //   tabs,
    // }
  },
  watch: {
    options: {
      handler() {
        this.Tissue_Detail()
      },
      deep: true,
    },
  },

  async mounted() {
    this.Tissue_Detail()
  },
  methods:{
      async Tissue_Detail() {
      const DonorId = this.$route.params.donor_id
      const service = new TissueService()
      let response = await service.TissueDetail_os(DonorId)
      // console.log("OSSS", response)
       if(response.os_id == null){
        //console.log("shubham")
        this.readOnlyField = true
        this.active_tab = "1"
      }if(response.od_id == null){
        //console.log("bhati")
        this.readOnlyField1 = true
        this.active_tab = "0"
      }if(response.os_id == null && response.od_id == null){
        //console.log("bhati new")
        this.readOnlyField = true
        this.readOnlyField1 = true
        this.active_tab = "2"
      }
  }
}
}

</script>

	

